import {
  CREATE_RETAIL_PROFILE,
  CREATE_RETAIL_PROFILE_SUCCESS,
  CREATE_RETAIL_PROFILE_FAILED,
  GET_RETAIL_PROFILES,
  GET_RETAIL_PROFILES_SUCCESS,
  GET_RETAIL_PROFILES_FAILED,
  GET_RETAIL_PROFILE_BY_ID,
  GET_RETAIL_PROFILE_BY_ID_SUCCESS,
  GET_RETAIL_PROFILE_BY_ID_FAILED,
  GET_RETAIL_PROFILES_BY_VENUE,
  GET_RETAIL_PROFILES_BY_VENUE_SUCCESS,
  GET_RETAIL_PROFILES_BY_VENUE_FAILED,
  UPDATE_RETAIL_PROFILE,
  UPDATE_RETAIL_PROFILE_SUCCESS,
  UPDATE_RETAIL_PROFILE_FAILED,
  DELETE_RETAIL_PROFILE_SUCCESS,
  CREATE_RETAIL_SCHEDULE,
  CREATE_RETAIL_SCHEDULE_SUCCESS,
  CREATE_RETAIL_SCHEDULE_FAILED,
  GET_SCHEDULES_BY_PROFILE,
  GET_SCHEDULES_BY_PROFILE_SUCCESS,
  GET_SCHEDULES_BY_PROFILE_FAILED,
  UPDATE_RETAIL_SCHEDULE_SUCCESS,
  DELETE_RETAIL_SCHEDULE_SUCCESS,
  SET_CURRENT_RETAIL_PROFILE,
  CLEAR_RETAIL_PROFILE_STATE,
} from './constants';

const initialState = {
  currentProfile: null,
  profile: null,
  profiles: [],
  schedules: [],
  profileDetails: null,
  error: null,
  loading: false,
  success: false,
};

const retailProfilesReducer = (state = initialState, action = null) => {
  switch (action.type) {
    case CREATE_RETAIL_PROFILE:
    case GET_RETAIL_PROFILES:
    case GET_RETAIL_PROFILE_BY_ID:
    case GET_RETAIL_PROFILES_BY_VENUE:
    case UPDATE_RETAIL_PROFILE:
    case CREATE_RETAIL_SCHEDULE:
    case GET_SCHEDULES_BY_PROFILE:
      return { ...state, loading: true, error: null };

    case CREATE_RETAIL_PROFILE_SUCCESS:
      return {
        ...state,
        currentProfile: action.payload.profile,
        profiles: [...state.profiles, action.payload.profile],
        loading: false,
        success: true,
        error: null,
      };

    case GET_RETAIL_PROFILES_SUCCESS:
    case GET_RETAIL_PROFILES_BY_VENUE_SUCCESS:
      return {
        ...state,
        profiles: action.payload.profiles,
        loading: false,
        error: null,
      };

    case GET_RETAIL_PROFILE_BY_ID_SUCCESS:
      return {
        ...state,
        profile: action.payload.profile,
        profileDetails: action.payload.profile,
        loading: false,
        error: null,
      };

    case UPDATE_RETAIL_PROFILE_SUCCESS:
      return {
        ...state,
        currentProfile: action.payload.profile,
        profiles: state.profiles.map((profile) =>
          profile.id === action.payload.profile.id ? action.payload.profile : profile,
        ),
        loading: false,
        success: true,
        error: null,
      };

    case DELETE_RETAIL_PROFILE_SUCCESS:
      return {
        ...state,
        profiles: state.profiles.filter((profile) => profile.id !== action.payload.id),
        currentProfile:
          state.currentProfile?.id === action.payload.id ? null : state.currentProfile,
        loading: false,
        error: null,
      };

    case CREATE_RETAIL_SCHEDULE_SUCCESS:
      return {
        ...state,
        schedules: [...state.schedules, action.payload.schedule],
        loading: false,
        success: true,
        error: null,
      };

    case GET_SCHEDULES_BY_PROFILE_SUCCESS:
      return {
        ...state,
        schedules: action.payload.schedules,
        loading: false,
        error: null,
      };

    case UPDATE_RETAIL_SCHEDULE_SUCCESS:
      return {
        ...state,
        schedules: state.schedules.map((schedule) =>
          schedule.id === action.payload.schedule.id ? action.payload.schedule : schedule,
        ),
        loading: false,
        success: true,
        error: null,
      };

    case DELETE_RETAIL_SCHEDULE_SUCCESS:
      return {
        ...state,
        schedules: state.schedules.filter((schedule) => schedule.id !== action.payload.id),
        loading: false,
        error: null,
      };

    case SET_CURRENT_RETAIL_PROFILE:
      return {
        ...state,
        currentProfile: action.payload.profile,
      };

    case CREATE_RETAIL_PROFILE_FAILED:
    case GET_RETAIL_PROFILES_FAILED:
    case GET_RETAIL_PROFILE_BY_ID_FAILED:
    case GET_RETAIL_PROFILES_BY_VENUE_FAILED:
    case UPDATE_RETAIL_PROFILE_FAILED:
    case CREATE_RETAIL_SCHEDULE_FAILED:
    case GET_SCHEDULES_BY_PROFILE_FAILED:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
        success: false,
      };

    case CLEAR_RETAIL_PROFILE_STATE:
      return initialState;

    default:
      return state;
  }
};

export default retailProfilesReducer;
